import { StateApplicationField } from "../../../models/sid/StateApplicationField";
import { HttpCrudRepo } from "../../HttpCrudRepo";
import StateApplicationFieldRepo from "./StateApplicationFieldRepo";
export class HttpStateApplicationFieldRepo extends HttpCrudRepo<StateApplicationField> implements StateApplicationFieldRepo {
    pathComponents = ['sid', 'v1', 'state-application-Field'];
}
